import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Api } from '../api'
import type { Feature } from '../feature'

export const executeAsk = store.effects.create(
  (feature: Feature, api: Api, meFeature: me.Feature) =>
    feature.actions.ask.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
      ),
      rxjs.switchMap(([action, context]) => {
        const { data: request } = action
        if (!context) {
          // Without a context, we can't do anything
          return rxjs.of(
            feature.actions.ask.error.from(action).create({
              error: new Error('Cannot determine current context'),
              request,
            }),
          )
        }
        // We call the API and return its result (or throw its error)
        return api.ask(context, request).pipe(
          rxjs.map(response =>
            feature.actions.ask.success
              .from(action)
              .create({ request, response }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.ask.error.from(action).create({ error, request }),
            ),
          ),
        )
      }),
    ),
)
